import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { CONTACT } from "@/data/site";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/services", label: "Services", testid: "nav-services-link" },
  { to: "/about", label: "About Us", testid: "nav-about-link" },
  { to: "/reviews", label: "Reviews", testid: "nav-reviews-link" },
  { to: "/store", label: "Online Store", testid: "nav-store-link" },
  { to: "/contact", label: "Book & Contact", testid: "nav-contact-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="nav-header"
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
        <Link to="/" data-testid="nav-logo" className="group flex items-center gap-2.5" onClick={() => setOpen(false)}>
          <span className="transition-transform duration-300 group-hover:scale-105">
            <Logo size={36} />
          </span>
          <span className="leading-none">
            <span className="font-display block text-base font-black uppercase tracking-tight text-white">
              Bowegans
            </span>
            <span className="font-mono2 block text-[10px] uppercase tracking-[0.3em] text-[#3B82F6]">
              Car Care
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" data-testid="nav-desktop-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `px-4 py-2 font-mono2 text-xs uppercase tracking-[0.2em] transition-colors ${
                  isActive ? "text-[#3B82F6]" : "text-gray-400 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={CONTACT.phoneLink}
            data-testid="nav-phone-button"
            className="flex items-center gap-2 border border-white/15 px-3 py-2 font-mono2 text-xs tracking-widest text-gray-300 transition-colors hover:border-[#3B82F6] hover:text-white"
          >
            <Phone className="h-3.5 w-3.5 text-[#3B82F6]" />
            {CONTACT.phone}
          </a>
          <a
            href={CONTACT.phone2Link}
            data-testid="nav-phone2-button"
            className="flex items-center gap-2 border border-white/15 px-3 py-2 font-mono2 text-xs tracking-widest text-gray-300 transition-colors hover:border-[#3B82F6] hover:text-white"
          >
            <Phone className="h-3.5 w-3.5 text-[#3B82F6]" />
            {CONTACT.phone2}
          </a>
          <Link
            to="/contact"
            data-testid="nav-book-button"
            className="bg-[#3B82F6] px-5 py-2 font-mono2 text-xs font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#2563EB]"
          >
            Book Service
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="text-white lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-black/95 px-4 py-4 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-${l.testid}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 font-mono2 text-sm uppercase tracking-[0.2em] ${
                    isActive ? "text-[#3B82F6]" : "text-gray-300"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={CONTACT.phoneLink}
              data-testid="mobile-nav-phone-button"
              className="mt-2 flex items-center gap-2 bg-[#3B82F6] px-3 py-3 font-mono2 text-sm font-bold uppercase tracking-widest text-white"
            >
              <Phone className="h-4 w-4" /> Call {CONTACT.phone}
            </a>
            <a
              href={CONTACT.phone2Link}
              data-testid="mobile-nav-phone2-button"
              className="flex items-center gap-2 border border-[#3B82F6] px-3 py-3 font-mono2 text-sm font-bold uppercase tracking-widest text-[#3B82F6]"
            >
              <Phone className="h-4 w-4" /> Call {CONTACT.phone2}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
